import ContainerLayout from '../components/ContainerLayout';
import CardContainer from '../components/CardContainer';
import Main from '../components/Main';
import { Box, TextContent, TopNavigation } from '@amzn/awsui-components-react';
import { AppURL } from '../constants/urls';
import { IMPRESSIONS } from '../constants/metrics';
import metricsService from '../services/metrics';

import aws_logo from '../assets/aws_logo.svg';
import headerStyles from '../components/TopNavigationBar.module.css';
import footerStyles from '../components/Footer.module.css';

import topNavigationMessages from '../i18n/TopNavigation.messages';
import footerMessages from '../i18n/footer.messages';
import errorMessages from '../i18n/error.messages';
import globalMessages from '../i18n/global.messages';
import { useEffect } from 'react';

function StaticError() {
  useEffect(() => {
    const metricsPublisher = metricsService.getPublisher('StaticErrorPage');
    metricsPublisher.publishCounterMonitor(IMPRESSIONS, 1);
  }, []);

  const Header = () => (
    <TopNavigation
      identity={{
        href: '#',
        title: topNavigationMessages.title.defaultMessage,
        logo: {
          src: aws_logo,
          alt: 'Logo',
        },
      }}
      className={headerStyles.disabledLink}
    />
  );

  const PipeSpacer = () => (
    <span className={footerStyles.pipeSpacer} aria-hidden="true">
      |
    </span>
  );

  const PrivacyLink = () => (
    <span>
      <a
        href="https://aws.amazon.com/privacy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {footerMessages.privacyLink.defaultMessage}
      </a>
    </span>
  );

  const SiteTermsLink = () => (
    <span>
      <a
        href="https://aws.amazon.com/terms/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {footerMessages.siteTermsLink.defaultMessage}
      </a>
    </span>
  );

  const CopyrightInformation = () => (
    <span>
      {footerMessages.copyrightInformation.defaultMessage.replace(
        '{year}',
        new Date().getFullYear().toString()
      )}
    </span>
  );

  const Footer = () => (
    <TextContent>
      <footer className={footerStyles.footer} role="contentinfo">
        <ul className={footerStyles.horizontal_list}>
          <li>
            <PrivacyLink />
          </li>
          <PipeSpacer />
          <li>
            <SiteTermsLink />
          </li>
          <PipeSpacer />
          <li>
            <CopyrightInformation />
          </li>
        </ul>
      </footer>
    </TextContent>
  );

  return (
    <>
      <Header />
      <Main>
        <ContainerLayout>
          <CardContainer
            header={errorMessages.errorHeader.defaultMessage}
            description={errorMessages.errorSubHeaderDescription.defaultMessage}
          >
            <p>{errorMessages.generalErrorMessage.defaultMessage}</p>
          </CardContainer>
          <TextContent>
            <Box margin={{ top: 's' }} float="left">
              <a
                href="https://support.aws.amazon.com/#/contacts/aws-training"
                target="_blank"
                rel="noopener noreferrer"
              >
                {globalMessages.supportLink.defaultMessage}
              </a>
            </Box>
            <Box margin={{ top: 's' }} float="right">
              <a href={AppURL.Help} target="_blank" rel="noopener noreferrer">
                {globalMessages.helpLink.defaultMessage}
              </a>
            </Box>
          </TextContent>
        </ContainerLayout>
      </Main>
      <Footer />
    </>
  );
}

export default StaticError;
